import { Link } from "react-router-dom";
import type { Topic } from "@/mocks/topics";
import { getTopicArticles } from "@/utils/news";

interface Props {
  topic: Topic;
  size?: "default" | "large";
}

export default function TopicCard({ topic, size = "default" }: Props) {
  const articleCount = getTopicArticles(topic).length;

  return (
    <Link
      to={`/topic/${topic.id}`}
      className="group relative block w-full aspect-[16/9] rounded-lg overflow-hidden bg-background-800 cursor-pointer"
    >
      <img
        src={topic.cover}
        alt={topic.title}
        title={`${topic.title} - 黑料吃瓜网专题`}
        className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/40 to-foreground-950/5" />
      <div className={`absolute inset-x-0 bottom-0 ${size === "large" ? "p-5 md:p-7" : "p-4 md:p-5"}`}>
        <div className="flex items-center gap-2 mb-2">
          <span className="px-2 py-0.5 rounded bg-accent-500 text-foreground-950 text-[10px] font-medium">
            专题
          </span>
          <span className="text-[11px] text-background-300">{articleCount} 篇文章</span>
        </div>
        <h3
          className={`font-heading font-bold text-background-50 leading-snug line-clamp-1 ${
            size === "large" ? "text-xl md:text-2xl" : "text-base md:text-lg"
          }`}
        >
          {topic.title}
        </h3>
        <p className="mt-1.5 text-[11px] md:text-xs text-background-300 line-clamp-1">{topic.subtitle}</p>
        <p className="hidden md:block mt-2 text-xs text-background-400/90 leading-relaxed line-clamp-2">
          {topic.intro}
        </p>
      </div>
    </Link>
  );
}